<template>
  <div class="page-container">
    <div class="page-title">
      Financial Settings
    </div>
    <div class="bottomContainer">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane v-for="(item,index) in componentConfig" :key="index" :label="item.label" :name="item.compName" />
      </el-tabs>
      <component :is="activeName" :key="activeName" @changeComponent="changeComponent" />
    </div>
    <!-- <ReviewResultModal /> -->
  </div>
</template>

<script>

import { getIsJTMerchant } from '@/api/data/data'

export default {
  name: 'Financial-Setting',
  components: {
    BankAccountList: () => import('./components/BankAccountList.vue'),
    CashOutSetting: () => import('./components/CashOutSetting.vue'),
    SplitReceiver: () => import('./components/SplitReceiver.vue')
    // ReviewResultModal: () => import('@/layout/components/Modal/ReviewResultModal.vue')
  },
  data() {
    this.SETTLEMENT_TYPE = {
      local: 1,
      usd: 2
    }
    return {
      isJTMerchant: false,
      activeName: 'BankAccountList'
    }
  },
  computed: {
    componentConfig() {
      if (this.$store.state.user.isJtMerchant || this.$store.state.user.isCargoMerchant) {
        return [
          { compName: 'BankAccountList', label: this.$t('data.bank_account_list') },
          { compName: 'SplitReceiver', label: this.$t('data.split_receiver') }
        ]
      } else {
        const list = [
          { compName: 'BankAccountList', label: this.$t('data.bank_account_list') },
          { compName: 'CashOutSetting', label: this.$t('data.cash_out_settng') }
        ]
        if (this.$store.getters.isID || this.$store.getters.isPii) {
          list.push({ compName: 'SplitReceiver', label: this.$t('data.split_receiver') })
        }
        return list
      }
    }
  },
  created() {
    this.$bus.emit('GET_NOTIFY')
    // this.getIsJTMerchant()
    // const { status } = this.$route.query
    // if (status) {
    //   this.activeName = this.statusArr[status]
    // }
  },
  methods: {
    getIsJTMerchant() {
      getIsJTMerchant().then(res => {
        this.isJTMerchant = res.data
      })
    },
    changeComponent(obj) {
      this.activeName = obj.compName
    }
  }
}
</script>

<style scoped>
.bottomContainer{
  margin: 20px;
  background: #fff;
  border-radius: 4px;
}
</style>
